<script lang="ts">
	import { Icon } from '@Shelly/shelly-design-system/index';

	/** FontAwesome icon class (used when no image is provided) */
	export let icon: string = '';
	/** Image URL for the thumbnail */
	export let image: string = '';
	/** Whether to show a notification badge (red dot) */
	export let hasNotification: boolean = false;
</script>

<div class="promo-thumbnail" class:promo-thumbnail--has-image={!!image}>
	{#if image}
		<img class="promo-thumbnail__image" src={image} alt="" />
	{:else}
		<div class="promo-thumbnail__icon-wrapper">
			<Icon size="s" {icon} />
		</div>
	{/if}
	{#if hasNotification}
		<span class="promo-thumbnail__badge" aria-hidden="true" />
	{/if}
</div>

<style>
	.promo-thumbnail {
		position: relative;
		flex-shrink: 0;
		width: 64px;
		height: 64px;
	}

	.promo-thumbnail__icon-wrapper {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: var(--color-2, #1b1d21);
		border-radius: 8px;
		box-shadow: 0 0 25px rgba(0, 0, 0, 0.75);
	}

	.promo-thumbnail__image {
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 8px;
		box-shadow: 0 0 25px rgba(0, 0, 0, 0.75);
	}

	.promo-thumbnail__badge {
		position: absolute;
		top: -3px;
		right: -3px;
		width: 12px;
		height: 12px;
		background: var(--color-danger, #ff4a50);
		border-radius: 50%;
		border: 2px solid var(--color-1, #242527);
	}
</style>
